module.exports = "/assets/_next/static/images/quiz-splash-bg@2x-14008f0521c962b927c3f4581f08bb32.jpg";